module.exports = __webpack_public_path__ + "img/passport-2.0087a3fb.png";